import { render } from "./BugTable.vue?vue&type=template&id=17954f2a&scoped=true"
import script from "./BugTable.vue?vue&type=script&lang=js"
export * from "./BugTable.vue?vue&type=script&lang=js"

import "./BugTable.vue?vue&type=style&index=0&id=17954f2a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17954f2a"]])

export default __exports__